<template>
  <div>
    <div class="l-container">
      <router-view :paymentdetail="paymentdetail"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    paymentdetail () {
      return this.$store.getters.paymentdetail
    }
  },
  methods: {
    getPaymentdetail (id) {
      this.$store.dispatch('getPaymentdetail', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getPaymentdetail(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Paymentdetail.vue?1518cc9a